import { GCS_BUCKET_URL } from '../config/api';

const newObjectId = () =>
  Array.from({ length: 24 }, () => Math.floor(Math.random() * 16).toString(16)).join('');

// Deep-clones a scene value, regenerating every field named exactly "id".
// Reference fields (*_id) are preserved so asset/character/state links remain valid.
export const reinitializeSceneIds = (value) => {
  if (Array.isArray(value)) return value.map(reinitializeSceneIds);
  if (value && typeof value === 'object') {
    return Object.fromEntries(
      Object.entries(value).map(([k, v]) => [k, k === 'id' ? newObjectId() : reinitializeSceneIds(v)])
    );
  }
  return value;
};

// Returns a flat list of all scenes in a novel with { id, name, type }.
export const getAllScenes = (novel) => {
  const scenes = [];
  novel?.interactive_scenes?.forEach(s => scenes.push({ id: s.id, name: s.name, type: 'interactive' }));
  novel?.static_scenes?.forEach(s => scenes.push({ id: s.id, name: s.name, type: 'static' }));
  novel?.open_world_interactive_scenes?.forEach(s => scenes.push({ id: s.id, name: s.name, type: 'open_world' }));
  return scenes;
};

// Returns the production cover image URL for a novel, or a fallback.
// Pass novelId explicitly when the novel object uses a different id field (e.g. novel.novel_id).
export const getNovelCoverUrl = (novel, novelId = null) => {
  const id = novelId || novel?.id;
  if (novel?.cover_background_image_id && novel?.cover_background_image_extension && id) {
    const url = `${GCS_BUCKET_URL}/production/${id}/background/${novel.cover_background_image_id}.${novel.cover_background_image_extension}`;
    return novel.cover_background_image_cache_id ? `${url}?cache_id=${novel.cover_background_image_cache_id}` : url;
  }
  return '/default-cover.jpg';
};
